module.exports = __webpack_public_path__ + "img/inu_gallery3.e7e5ea39.jpg";